export const BASE_URL = import.meta.env.VITE_API_URL
export const ENV = import.meta.env.VITE_APP_ENV || 'local'

export const PUBLIC_ENDPOINTS = {
  website: {
    help: '/mail/help',
    forgotPassword: '/mail/forgotPassword',
  },
}

export const PRIVATE_ENDPOINTS = {
  auth: {
    login: '/auth/login',
  },

  user: {
    create: '/user',
    all: '/user',
    single: (id: number) => `/user/${id}`,
    update: (id: number) => `/user/${id}`,
    delete: (id: number) => `/user/${id}`,
  },

  analysis: {
    create: '/analysis',
    all: '/analysis',
    single: (id: number) => `/analysis/${id}`,
    update: (id: number) => `/analysis/${id}`,
    delete: (id: number) => `/analysis/${id}`,
  },

  city: {
    all: '/city',
    single: (id: number) => `/city/${id}`,
  },
}
